module.exports = __webpack_public_path__ + "img/logo-wuerth.6efa6ea4.svg";